import React from 'react';

export const Spinner = () => {
  return (
    <div className='text-center'>Loading ...</div>
  );
};
